import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/pro-solid-svg-icons'

import { CourseTypes, TypesRequests } from 'enum'
import download from 'api/allCoursesRequest/download'
import { useAccess } from 'contexts/AccessContext'
import styles from './DownloadReport.module.scss'

interface Params {
  type: TypesRequests
  typeCourse?: CourseTypes | null
}

export const DownloadReport = ({ type, typeCourse }: Params) => {
  const { t } = useTranslation()
  const [loading, setLoading] = React.useState(false)
  const { access } = useAccess()

  if (!access.canDownloadReportWithViewAccess()) {
    return null
  }

  return (
    <Dropdown.Item
      onClick={() => {
        setLoading(true)
        download({ type, typeCourse })
          .then((url) => {
            setLoading(false)
            window.open(url, '_blank')
          })
          .catch(() => {
            setLoading(false)
          })
      }}
      disabled={loading}
      className={styles.dropdownItem}
    >
      {t('administration.applications.actions.report')}
      {loading && (
        <div className={styles.loadingRoot}>
          <div>
            <FontAwesomeIcon icon={faSpinner} spin className="mr-1 " />{' '}
          </div>
        </div>
      )}
    </Dropdown.Item>
  )
}
export default DownloadReport
